import React, { useEffect, useRef } from 'react'
import { useLocation, Outlet } from 'react-router'
import { trackAnalyticEvent } from '../utils'

export function PageTracker() {
	const location = useLocation()
	const isPreviouslyViewed = useRef<Set<string>>( new Set() )

	useEffect( () => {
		const signature = `${location.pathname}|${document.title}`

		if ( isPreviouslyViewed.current.has( signature ) ) {
			return
		} // ignore StrictMode duplicate
		isPreviouslyViewed.current.add( signature )

		const page = `${document.title.split( '-' )[ 1 ].trim()} Page`

		trackAnalyticEvent( page, 'View', 'Page View' )
	}, [ location.pathname ] )

	return <Outlet />
}
